import { AnyAction } from 'redux';
import { call, put, takeLatest } from 'redux-saga/effects';

import * as Constants from '../constants';
import * as Services from '../services';

function* getGroup(action: AnyAction) {
  try {
    const response: any = yield call(Services.getGroup, action.groupId);
    if (response.data && response.data.message === 'OK') {
      yield put({ type: Constants.GET_GROUP_SUCCESS, payload: response.data.data });
      action.resolve('ok');
    }
  } catch (e) {
    action.reject(e);
    yield put({ type: Constants.GET_GROUP_FAILED, e });
  }
}

function* createGroup(action: AnyAction) {
  try {
    const response: any = yield call(Services.createGroup, action.infos);
    if (response.data.message === 'OK') {
      yield put({ type: Constants.CREATE_GROUP_SUCCESS, payload: response.data.data });
      action.resolve('ok');
    }
  } catch (e) {
    action.reject(e);
    yield put({ type: Constants.CREATE_GROUP_FAILED, e });
  }
}

function* updateGroup(action: AnyAction) {
  try {
    const response: any = yield call(Services.updateGroup, action.infos);
    if (response.data.message === 'OK') {
      yield put({ type: Constants.UPDATE_GROUP_SUCCESS, payload: response.data.data });
      action.resolve('ok');
    }
  } catch (e) {
    action.reject(e);
    yield put({ type: Constants.UPDATE_GROUP_FAILED, e });
  }
}

export const groupSagas = [
  takeLatest(Constants.GET_GROUP, getGroup),
  takeLatest(Constants.CREATE_GROUP, createGroup),
  takeLatest(Constants.UPDATE_GROUP, updateGroup)
];


function* getAgency(action: AnyAction) {
  try {
    const response: any = yield call(Services.getAgency, action.groupId);
    if (response) {
      yield put({ type: Constants.GET_AGENCY_SUCCESS, payload: response });
      action.resolve(response);
    }

  } catch (e) {
    action.reject(e);
    yield put({ type: Constants.GET_AGENCY_FAILED, e });
  }
}

function* updateAgency(action: AnyAction) {
  try {
    const response: any = yield call(Services.updateAgency, action.infos, action.agencyId);
    if (response?.data?.message === 'OK') {
      yield put({ type: Constants.UPDATE_AGENCY_SUCCESS, payload: response.data.data });
      action.resolve('ok');
    }
  } catch (e) {
    action.reject(e);
    yield put({ type: Constants.UPDATE_AGENCY_FAILED, e });
  }
}

export const agencySagas = [
  takeLatest(Constants.GET_AGENCY, getAgency),
  takeLatest(Constants.UPDATE_AGENCY, updateAgency)
];
